import { FC, forwardRef, SVGProps, useImperativeHandle } from 'react';
import { Box, Button, Dialog, Stack, Typography } from '@mui/material';
import { useOpen } from '../../../app/hooks';

import FileCheckedIcon from '@/app/assets/icons/file-checked.svg?react';

import { InfoModalRef } from './types';
import { t } from 'i18next';

interface Props {
  Icon?: FC<
    SVGProps<SVGSVGElement> & {
      title?: string;
    }
  >;
  title: string;
  subtitle?: string;
}
export const InfoModal = forwardRef<InfoModalRef, Props>(
  ({ Icon = FileCheckedIcon, title, subtitle }, ref) => {
    const { open, setOpen } = useOpen();

    useImperativeHandle(ref, () => ({
      open: onOpen,
    }));

    const onOpen = () => {
      setOpen(true);
    };

    const onClose = () => {
      setOpen(false);
    };

    return (
      <Dialog
        open={open}
        PaperProps={{
          sx: {
            maxWidth: 640,
            width: '100%',
            p: 4,
          },
        }}
      >
        <Stack spacing={4} alignItems='center' justifyContent='center'>
          <Stack
            alignItems='center'
            justifyContent='center'
            sx={{
              bgcolor: 'rgba(21, 85, 252, 0.04)',
              borderRadius: '50%',
              width: 80,
              height: 80,
            }}
          >
            <Box component={Icon} />
          </Stack>

          <Stack alignItems='center' textAlign='center'>
            <Typography variant='h4'>{title}</Typography>

            {subtitle && (
              <Typography mt={1} variant='subtitle2'>
                {subtitle}
              </Typography>
            )}
          </Stack>

          <Button onClick={onClose}>{t('close')}</Button>
        </Stack>
      </Dialog>
    );
  }
);
